import type { SpringOptions } from 'motion/react'

/**
 * Spring for values that follow a changing target, such as amounts and the
 * modal stack's layers.
 */
export const followSpring: SpringOptions = {
  stiffness: 170,
  damping: 26,
  mass: 1,
}
